import React, { FC } from 'react';
import {
  ContactWrapper,
  FacebookIcon,
  IconWrapper,
  InstagramIcon,
  Link,
  LinkedinIcon,
  LocationIcon,
  MailIcon,
  NetworkWrapper,
  PhoneIcon,
  SingleContactWrapper,
  Text,
  TextWrapper,
  Title,
  WhatsappIcon,
  Wrapper,
} from './styles';

const FooterSection: FC = () => {
  return (
    <Wrapper>
      <ContactWrapper>
        <Title>Contato</Title>
        <SingleContactWrapper>
          <LocationIcon />
          <TextWrapper>
            <Text>
              {`Torre Business - R. das Orquídeas, 777 - sala 306 - Jardim Pompeia,
              Indaiatuba - SP, 13345-040`}
            </Text>
          </TextWrapper>
        </SingleContactWrapper>
        <SingleContactWrapper>
          <PhoneIcon />
          <TextWrapper>
            <Link href="tel:19971593137">
              <Text>Cel: (19) 97159-3137</Text>
            </Link>
            <Link href="tel:1931153213">
              <Text>Fixo: (19) 3115-3213</Text>
            </Link>
          </TextWrapper>
        </SingleContactWrapper>
        <SingleContactWrapper>
          <MailIcon />
          <TextWrapper>
            <Link href="mailto:contato@danielecarbonez.com.br">
              <Text>contato@danielecarbonez.com.br</Text>
            </Link>
          </TextWrapper>
        </SingleContactWrapper>
      </ContactWrapper>
      <NetworkWrapper>
        <Title>
          Rede <b>Sociais</b>
        </Title>
        <IconWrapper>
          <Link
            href="https://www.facebook.com/danielecarbonez.arq/"
            target="_blank"
          >
            <FacebookIcon />
          </Link>
          <Link
            href="https://www.instagram.com/danielecarbonez/"
            target="_blank"
          >
            <InstagramIcon />
          </Link>
          <Link
            href="https://api.whatsapp.com/send?phone=5519995267316&text=Olá, gostaria de um orçamento"
            target="_blank"
          >
            <WhatsappIcon />
          </Link>
        </IconWrapper>
      </NetworkWrapper>
    </Wrapper>
  );
};

export default FooterSection;
